"use client";

import { getDeviceId } from "@/utils/getToken";
import { useRouter } from "next/router";

const useGoogleAuth = () => {
  const router = useRouter();
  const { referralLink } = router.query;
  const API_URL = process.env.NEXT_PUBLIC_API?.slice(0, -7);

  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";

  const redirectUri = origin + "/oauth2/redirect";

  const deviceId = getDeviceId();

  const googleAuthUrl = (() => {
    const url = new URL("/oauth2/authorization/google", API_URL);
    url.search = new URLSearchParams({
      redirectUri,
      deviceId,
      ...(referralLink ? { superId: referralLink } : {}),
    }).toString();
    return url.toString();
  })();

  return { googleAuthUrl, referralLink };
};

export default useGoogleAuth;
